export const GET_GLC_SUCCESS = "GET_GLC_SUCCESS";
export const GET_GLC_FAILURE = "GET_GLC_FAILURE";

export const ADD_GLC_SUCCESS = "ADD_GLC_SUCCESS";
export const ADD_GLC_FAILURE = "ADD_GLC_FAILURE";

export const DELETE_GLC_SUCCESS = "DELETE_GLC_SUCCESS";
export const DELETE_GLC_FAILURE = "DELETE_GLC_FAILURE";
